(function () {
  function isFormField(target) {
    if (!target || !target.closest) return false;
    return !!target.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""]');
  }

  // Block the right-click / long-press context menu everywhere except
  // inside actual form fields, where users may still want it (e.g. to
  // paste into a search box).
  document.addEventListener('contextmenu', function (e) {
    if (!isFormField(e.target)) {
      e.preventDefault();
    }
  });

  // Block copy / cut of page content. Still allowed inside form fields.
  document.addEventListener('copy', function (e) {
    if (!isFormField(e.target)) {
      e.preventDefault();
    }
  });

  document.addEventListener('cut', function (e) {
    if (!isFormField(e.target)) {
      e.preventDefault();
    }
  });

  // Backstop for browsers/situations where the CSS user-select rules
  // don't fully suppress selection on their own.
  document.addEventListener('selectstart', function (e) {
    if (!isFormField(e.target)) {
      e.preventDefault();
    }
  });
})();
